import { render, staticRenderFns } from "./PositionFairPayCard.vue?vue&type=template&id=620dee08&scoped=true"
import script from "./PositionFairPayCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionFairPayCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionFairPayCard.vue?vue&type=style&index=0&id=620dee08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dee08",
  null
  
)

export default component.exports